<template>
    <div>
        <tag-rounded 
            :label="tagsHuman[type].label"
            :color="tagsHuman[type].color"
            :bgcolor="tagsHuman[type].bgcolor"
            class="mr-1">
        </tag-rounded>
    </div>
</template>

<script>
    import TagHumansConfig from 'Config/authenticated/TagHumans'
    import TagRounded from 'vcomponents/utilities/TagRounded.vue';

    export default {
        name: 'TagRelationTypeColumn',
        props: {
            type: {
                type: String,
                required: true
            }
        },
        computed: {
            tagsHuman() {
                return TagHumansConfig
            }
        },
        components: {
            TagRounded
        }
    }
</script>
